import React, { useEffect, useState } from "react";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import classes from "./Messages.module.css";
import Colors from "../../../stories/assets/Colors";
import { Col, Container, Row } from "react-bootstrap";
import ChatScreen from "./chat/chat";
import ChatScreenClasses from "./chat/chat.module.css";
import MessagesMobile from "./MessagesMobile";

const MessagesDesktop = () => {
  const onClickSearch = (data) => {
    console.log(data);
  };

  const handleSearch = (data) => {
    console.log(data);
  };
  return (
    <>
      <style>
        {`
          .${ChatScreenClasses.userChatMainDiv} {
            height: calc(100vh - 180px);
          }
          .${ChatScreenClasses.container} {
            height: auto !important;
          }
          .${ChatScreenClasses.chattingBoxRow} {
            height: calc(100vh - 176px);
          }
        `}
      </style>
      <div>
        <div
          className={[classes.headerDiv]}
          style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        >
          <AfterLoginHeader
            onClickSearch={onClickSearch}
            showSearch={true}
            onSubmitSearch={handleSearch}
          />
        </div>
        <Container fluid className={[classes.mainContainer]}>
          <ChatScreen />
        </Container>
      </div>
    </>
  );
};

const Messages = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <MessagesMobile /> : <MessagesDesktop />;
};

export default Messages;
